setQueueItem